import React from "react";
import { motion } from "framer-motion";

export const SnapSolveWidget: React.FC = () => {
  return (
    <motion.a
      href="https://snapsolve.ink"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Made with love by SnapSolve"
      draggable={false}
      onDragStart={(event) => event.preventDefault()}
      initial={{ y: 18, opacity: 0, scale: 0.97 }}
      animate={{ y: 0, opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 24, delay: 0.45 }}
      whileHover={{ scale: 1.015 }}
      whileTap={{ scale: 0.99 }}
      className="group fixed bottom-4 left-1/2 z-[9999] flex w-[calc(100vw-2rem)] max-w-[36rem] -translate-x-1/2 items-center justify-between gap-4 rounded-full border border-white/12 bg-[#101010]/92 px-5 py-3 text-white shadow-[0_20px_70px_rgba(0,0,0,0.55),inset_0_1px_0_rgba(255,255,255,0.08)] outline-none backdrop-blur-xl focus-visible:ring-2 focus-visible:ring-red-300/80 sm:bottom-8 sm:px-10 sm:py-5"
    >
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 rounded-full border border-white/10"
      />
      <span className="relative min-w-0 text-[clamp(1rem,4.6vw,1.85rem)] font-semibold leading-none tracking-normal text-[#e8e8ee]">
        Made with love by SnapSolve
      </span>
      <span className="relative grid size-12 shrink-0 place-items-center overflow-hidden rounded-full border border-black/20 bg-white shadow-[inset_0_2px_5px_rgba(255,255,255,0.9),inset_0_-3px_8px_rgba(0,0,0,0.25),0_0_0_3px_rgba(255,255,255,0.18)] sm:size-14">
        <img
          src="/snapsolve.png"
          alt=""
          aria-hidden="true"
          draggable={false}
          className="size-full rounded-full object-cover"
        />
      </span>
    </motion.a>
  );
};
